import React from 'react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#4B77A8] flex items-center justify-center p-6 font-sans text-white">
      <div className="max-w-5xl w-full flex flex-col md:flex-row items-center justify-center gap-12 md:gap-24">
        
        {/* Left Column: Robot Graphic */}
        <div className="w-64 md:w-auto flex justify-center">
           {/* Replace this placeholder with your actual robot SVG/PNG */}
           <img 
             src="/robot-illustration.svg" 
             alt="Confused Robot" 
             className="w-full max-w-[300px] object-contain drop-shadow-md"
           />
        </div>

        {/* Right Column: Typography & Button */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          
          <h1 className="text-6xl md:text-[5.5rem] font-medium tracking-wide mb-4">
            Oops!
          </h1>
          
          <h2 className="text-2xl md:text-[2.5rem] font-light mb-8 whitespace-nowrap">
            404 Page Not Found
          </h2>
          
          <div className="text-lg md:text-2xl font-light tracking-wide text-gray-100 mb-10 flex flex-col gap-2">
            <p>You Gotta Do</p>
            <p>What You Gotta Do</p>
          </div>

          <button 
            onClick={() => window.history.back()}
            className="px-10 py-3 bg-white text-gray-800 font-semibold rounded-md hover:bg-gray-100 transition-colors duration-200 shadow-sm"
          >
            Go Back
          </button>
          
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;